import type { Filter } from '../types';
import { BaseSelectColumnFilter } from './BaseSelectColumnFilter';

export const SelectColumnFilter: Filter = (props) => (
  <BaseSelectColumnFilter
    {...props}
    compareValues={(a, b) => String(a).localeCompare(String(b))}
  />
);
